// // import React, { useState } from "react";
// // import {
// //   Box,
// //   Typography,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   Paper,
// //   TextField,
// //   IconButton,
// // } from "@mui/material";
// // import SendIcon from "@mui/icons-material/Send";

// // const chatList = [
// //   { id: 1, name: "Indhuja", message: "Just now I saw your job post..." },
// //   { id: 2, name: "Cygnusa", message: "We’ve recently seen an increase..." },
// //   { id: 3, name: "Ganesh", message: "You’re welcome..." },
// //   { id: 4, name: "Neha", message: "Thank you..." },
// //   { id: 5, name: "Angel", message: "https://www.linkedin.com/p..." },
// // ];

// // function MessageChat() {
// //   const [selectedChat, setSelectedChat] = useState(chatList[0]);
// //   const [messageInput, setMessageInput] = useState("");

// //   const handleSend = () => {
// //     if (messageInput.trim()) {
// //       alert(`Message sent: ${messageInput}`);
// //       setMessageInput("");
// //     }
// //   };

// //   return (
// //     <Box sx={{ display: "flex", height: "100vh", backgroundColor: "#f5f5f5" }}>
// //       {/* Sidebar */}
// //       <Paper elevation={3} sx={{ width: 300, overflowY: "auto" }}>
// //         <Typography variant="h5" sx={{ p: 2 }}>
// //           Messages
// //         </Typography>
// //         <List>
// //           {chatList.map((chat) => (
// //             <ListItem
// //               key={chat.id}
// //               button
// //               selected={selectedChat.id === chat.id}
// //               onClick={() => setSelectedChat(chat)}
// //               sx={{
// //                 "&.Mui-selected": {
// //                   backgroundColor: "#1976d2",
// //                   color: "#fff",
// //                 },
// //               }}
// //             >
// //               <ListItemText
// //                 primary={<strong>{chat.name}</strong>}
// //                 secondary={chat.message}
// //                 secondaryTypographyProps={{
// //                   noWrap: true,
// //                   color: "inherit",
// //                 }}
// //               />
// //             </ListItem>
// //           ))}
// //         </List>
// //       </Paper>

// //       {/* Chat View */}
// //       <Box sx={{ flex: 1, p: 2, display: "flex", flexDirection: "column" }}>
// //         <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
// //           <Typography variant="h6">{selectedChat.name}</Typography>
// //           <Typography variant="body1">{selectedChat.message}</Typography>
// //         </Paper>

// //         {/* Chat Input */}
// //         <Box
// //           sx={{
// //             mt: "auto",
// //             display: "flex",
// //             alignItems: "center",
// //             p: 1,
// //             borderTop: "1px solid #ddd",
// //             backgroundColor: "#fff",
// //           }}
// //         >
// //           <TextField
// //             fullWidth
// //             variant="outlined"
// //             placeholder="Message..."
// //             value={messageInput}
// //             onChange={(e) => setMessageInput(e.target.value)}
// //             sx={{ mr: 1 }}
// //           />
// //           <IconButton color="primary" onClick={handleSend}>
// //             <SendIcon />
// //           </IconButton>
// //         </Box>
// //       </Box>
// //     </Box>
// //   );
// // }
// // export default MessageChat

// import React, { useState } from "react";
// import {
//     Box,
//     Typography,
//     List,
//     ListItem,
//     ListItemText,
//     Paper,
//     TextField,
//     IconButton,
//     Divider,
//     Avatar,
//     Grid,
// } from "@mui/material";
// import SendIcon from "@mui/icons-material/Send";
// import profile_image from "../../../Assets/Media.jpg"

// const chatList = [
//     { id: 1, name: "Indhuja", message: "Just now I saw your job post..." },
//     { id: 2, name: "Cygnusa", message: "We’ve recently seen an increase..." },
//     { id: 3, name: "Ganesh", message: "You’re welcome..." },
//     { id: 4, name: "Neha", message: "Thank you..." },
//     { id: 5, name: "Angel", message: "https://www.linkedin.com/p..." },
//     { id: 6, name: "Indhuja", message: "Just now I saw your job post..." },
//     { id: 7, name: "Cygnusa", message: "We’ve recently seen an increase..." },
//     { id: 8, name: "Ganesh", message: "You’re welcome..." },
// ];

// function MessageChat() {
//     const [selectedChat, setSelectedChat] = useState(chatList[0]);
//     const [messageInput, setMessageInput] = useState("");

//     // Store messages with a structure: { from: "me" | "them", text: "..." }
//     const [messages, setMessages] = useState([
//         { from: "them", text: selectedChat.message },
//     ]);

//     const handleSend = () => {
//         if (messageInput.trim()) {
//             setMessages((prev) => [...prev, { from: "me", text: messageInput }]);
//             setMessageInput("");
//         }
//     };

//     const handleChatSelect = (chat) => {
//         setSelectedChat(chat);
//         setMessages([{ from: "them", text: chat.message }]);
//         setMessageInput("");
//     };

//     return (
//         <Grid container spacing={4}
//             sx={{
//                 display: "flex",
//                 height: "80vh",
//                 // backgroundColor: "#f5f5f5"
//             }}
//         >
//             <Grid size={{ md: 4,mr:2 }}>

//                 <Paper elevation={3} sx={{
//                     width: 300,

//                 }}>
//                     <Typography variant="h5" sx={{ p: 2, background: "var(--main-color)", color: "white" }}>
//                         Messages
//                     </Typography>
//                     <Divider />
//                     <Box sx={{
//                         height: "70vh", overflowY: "auto",
//                         //  background: "yellow" 
//                     }}>
//                         <List>
//                             {chatList.map((chat) => (
//                                 <ListItem
//                                     key={chat.id}
//                                     button
//                                     selected={selectedChat.id === chat.id}
//                                     onClick={() => handleChatSelect(chat)}
//                                     sx={{
//                                         backgroundColor: selectedChat.id === chat.id ? "var(--main-contentbackgroundcolor)" : "white",
//                                         borderBottom: "1px solid gray",
//                                         "&.Mui-selected": {
//                                             // backgroundColor: selectedChat.id === chat.id ? "red" : "#1976d2",
//                                             color: "#fff",
//                                         },
//                                     }}
//                                 >
//                                     <Avatar src={profile_image}
//                                         sx={{
//                                             border: "1px solid gray",
//                                             mr: 1,
//                                             "& .MuiAvatar-img": {
//                                                 objectFit: "contain"
//                                             }
//                                         }} />
//                                     <ListItemText
//                                         primary={
//                                             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '15px', color: 'black' }}>
//                                                 {chat.name}
//                                             </Typography>
//                                         }
//                                         secondary={
//                                             <Typography
//                                                 variant="body1"
//                                                 sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', color: "gray" }}
//                                             >
//                                                 {chat.message}
//                                             </Typography>
//                                         }
//                                         secondaryTypographyProps={{
//                                             component: "div", // Optional, helps keep the Typography structure
//                                             color: "inherit"
//                                         }}
//                                     />

//                                 </ListItem>
//                             ))}
//                         </List>
//                     </Box>
//                 </Paper>
//             </Grid>
//             {/* Chat View */}
//             <Grid size={{ md: 8}}>

//                 <Box sx={{
//                     flex: 1,
//                     // p: 2,
//                     display: "flex",
//                     flexDirection: "column",
//                     height: "79vh",
//                     border: "1px solid gray",
//                     background: "var(--main-contentbackgroundcolor)"
//                 }}>
//                     <Box sx={{ p: 1, background: "var(--main-color)" ,display:"flex",justifyContent:"start",alignItems:"center"}}>
//                         {/* <Box> */}
//                             <Avatar src={profile_image}
//                                 sx={{
//                                     border: "1px solid gray",
//                                     mr: 1,
//                                     "& .MuiAvatar-img": {
//                                         objectFit: "contain"
//                                     }
//                                 }} />
//                             <Typography variant="h6"
//                             //  sx={{ background: "red" }}
//                              >
//                                 {selectedChat.name}
//                             </Typography>
//                         {/* </Box> */}
//                     </Box>

//                     {/* Messages */}
//                     <Box sx={{ flex: 1, overflowY: "auto", mb: 2,p:2}}>
//                         {messages.map((msg, index) => (
//                             <Box
//                                 key={index}
//                                 sx={{
//                                     display: "flex",
//                                     justifyContent: msg.from === "me" ? "flex-end" : "flex-start",
//                                     mb: 1,
//                                 }}
//                             >
//                                 <Box
//                                     sx={{
//                                         maxWidth: "70%",
//                                         p: 1.5,
//                                         borderRadius: 2,
//                                         backgroundColor:
//                                             msg.from === "me" ? "#1976d2" : "#e0e0e0",
//                                         color: msg.from === "me" ? "#fff" : "#000",
//                                     }}
//                                 >
//                                     {msg.text}
//                                 </Box>
//                             </Box>
//                         ))}
//                     </Box>

//                     {/* Chat Input */}
//                     <Box
//                         sx={{
//                             mt: "auto",
//                             display: "flex",
//                             alignItems: "center",
//                             p: 1,
//                             borderTop: "1px solid #ddd",
//                             backgroundColor: "#fff",
//                         }}
//                     >
//                         <TextField
//                             fullWidth
//                             variant="outlined"
//                             placeholder="Message..."
//                             value={messageInput}
//                             onChange={(e) => setMessageInput(e.target.value)}
//                             sx={{ mr: 1 }}
//                         />
//                         <IconButton color="primary" type="submit" onClick={handleSend}>
//                             <SendIcon />
//                         </IconButton>
//                     </Box>
//                 </Box>
//             </Grid>
//         </Grid>

//     );
// }

// export default MessageChat;



import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    Paper,
    TextField,
    IconButton,
    Divider,
    Avatar,
    Grid,
    useTheme,
    useMediaQuery,
    Badge,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import profile_image from "../../../Assets/Media.jpg"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { useDispatch, useSelector } from 'react-redux'
// import actions from '../../../ReduxStore/actions'
import { useDispatch, useSelector } from 'react-redux'
import actions from '../../../ReduxStore/actions'
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { format } from 'date-fns';
import CustomInputWithEmoji from "../../../Components/CustomInputLogin/CustomInputWithEmoji";
import { Form, Formik } from "formik";
import CustomInputWithMessageEmoji from "../../../Components/CustomInputLogin/CustomInputWithMessageEmoji";

const chatList = [
    { id: 1, name: "Indhuja", message: "Just now I saw your job post..." },
    { id: 2, name: "Cygnusa", message: "We’ve recently seen an increase..." },
    { id: 3, name: "Ganesh", message: "You’re welcome..." },
    { id: 4, name: "Neha", message: "Thank you..." },
    { id: 5, name: "Angel", message: "https://www.linkedin.com/p..." },
    { id: 6, name: "Indhuja", message: "Just now I saw your job post..." },
    { id: 7, name: "Cygnusa", message: "We’ve recently seen an increase..." },
    { id: 8, name: "Ganesh", message: "You’re welcome..." },
];

function MessageChat() {
    const [selectedChat, setSelectedChat] = useState("");
    const [messageInput, setMessageInput] = useState("");

    const dispatch = useDispatch()


    const { GetAllChatRoomsWithReceiverInfo } = useSelector(
        (state) => state?.GetAllChatRoomsWithReceiverInfo
    );

    const { sendMessage } = useSelector(
        (state) => state?.sendMessage
    );
    const { GetchatRoomMessage } = useSelector(
        (state) => state?.GetchatRoomMessage
    );



    const { markRoomNotificationsAsRead } = useSelector(
        (state) => state?.markRoomNotificationsAsRead
    );

    console.log(GetAllChatRoomsWithReceiverInfo?.data, "GetAllChatRoomsWithReceiverInfo");

    // Store messages with a structure: { from: "me" | "them", text: "..." }
    const [messages, setMessages] = useState([
        // { from: "them", text: "bnsjdsndd" },
        // { from: "me", text: "sbsbsjdsbdjjdsjdjs" },
    ]);



    const handleSend = async (fullroomchat, postText) => {
        console.log(fullroomchat, "fullroomchat");
        if (postText?.trim()) {
            const data1 = {
                data: {
                    "room_id": fullroomchat?.chatRoom?.room_id,
                    "sender_id": fullroomchat?.chatRoom?.you?.user_id,
                    "content": postText
                },
                method: "post",
                apiName: `sendMessage`,
            };
            const response = await dispatch(actions.SENDMESSAGE(data1));
            console.log(response, "SENDMESSAGESENDMESSAGE");
            setMessageInput("");

            const data = {
                data: {},
                method: "get",
                apiName: `GetchatRoomMessage/room/${fullroomchat?.chatRoom?.room_id}/user/${sessionUserId}`,
            };
            const response1 = await dispatch(actions.GETCHATROOMMESSAGE(data));
            console.log(response1, "GetchatRoomMessageGetchatRoomMessage");

            setSelectedChat(response1?.payload?.data);
            setMessages(response1?.payload?.data);





        }

        // if (messageInput.trim()) {
        //     setMessages((prev) => [...prev, { from: "me", text: messageInput }]);
        //     setMessageInput("");
        // }
    };

    const handleChatSelect = async (chat) => {

        const data = {
            data: {
                "room_id": chat.room_id
            },
            method: "put",
            apiName: `markRoomNotificationsAsRead/${sessionUserId}`,
        };
        const response1 = await dispatch(actions.GETCHATROOMMESSAGE(data));

        const data1 = {
            data: {},
            method: "get",
            apiName: `GetchatRoomMessage/room/${chat.room_id}/user/${sessionUserId}`,
        };
        const response = await dispatch(actions.GETCHATROOMMESSAGE(data1));
        console.log(response, "GetchatRoomMessageGetchatRoomMessage");

        setSelectedChat(response?.payload?.data);
        // setMessages([{ from: "them", text: chat.message }]);
        setMessages(response?.payload?.data);

        if (isMobile) {
            setShowChatViewOnMobile(true); // Switch to chat view on mobile
        }
        setMessageInput("");


        const data5 = {
            data: {},
            method: "get",
            apiName: `getNotificationCategoryCounts/${sessionUserId}`,
        };
        const response5 = await dispatch(actions.GETNOTIFICATIONCATEGORYCOUNTS(data5));



    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [showChatViewOnMobile, setShowChatViewOnMobile] = useState(false);

    // const handleChatSelect = (chat) => {
    //     setSelectedChat(chat);
    //     if (isMobile) {
    //         setShowChatViewOnMobile(true); // Switch to chat view on mobile
    //     }
    // };

    const handleBackToChatList = () => {
        setShowChatViewOnMobile(false); // Back to chat list
    };


    const sessionUserId = sessionStorage.getItem("userId")

    useEffect(() => {
        const fetchChatRooms = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `GetAllChatRoomsWithReceiverInfo/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETALLCHATROOMSWITHRECEIVERINFO(data1));
            console.log(response, "responsedataaaaaaa");

        };
        fetchChatRooms();
    }, [messages, markRoomNotificationsAsRead]);


    // useEffect(() => {
    //     const fetchChatRooms = async () => {
    //         if (messages?.messages?.chatRoom?.room_id) {
    //             const data2 = {
    //                 data: {},
    //                 method: "get",
    //                 apiName: `GetchatRoomMessage/room/${messages?.messages?.chatRoom.room_id}/user/${sessionUserId}`,
    //             };
    //             const response1 = await dispatch(actions.GETCHATROOMMESSAGE(data2));

    //             console.log(response1, "GetchatRoomMessageGetchatRoomMessage");
    //             setMessages(response1?.payload?.data);

    //         }
    //     };

    //     fetchChatRooms();
    // }, [messages]);

    console.log(messages, "messagesmessages");

    console.log(selectedChat, "selectedChatselectedChat");


    const formatTimeOnly = (timestamp) => {
        if (!timestamp) return '';
        return new Date(timestamp).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    const formatTime = (timestamp) => {
        if (!timestamp) return '';

        const date = new Date(timestamp);

        const formattedDate = date.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
        });

        const formattedTime = date.toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
        });

        return `${formattedDate} at ${formattedTime}`;
    };

    const getFormattedDate = (date) => {
        return format(new Date(date), "MMM dd, yyyy");
    };

    // Check if a new day is reached to display the date
    const getMessageDate = (msg, index, messages) => {
        const isNewDay =
            index === 0 ||
            dayjs(msg.createdAt).format("YYYY-MM-DD") !== dayjs(messages[index - 1].createdAt).format("YYYY-MM-DD");

        if (isNewDay) {
            return (
                <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
                    <Box sx={{ padding: "5px 10px", backgroundColor: "#e0e0e0", borderRadius: 2 }}>
                        <Typography variant="body2" sx={{ fontWeight: "bold", color: "#555" }}>
                            {getFormattedDate(msg.createdAt)}
                        </Typography>
                    </Box>
                </Box>
            );
        }
        return null;
    };

    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };
    const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';


    return (
        <Grid container spacing={2} sx={{ height: "80vh" }}>
            {/* Chat List - show only on desktop or when not viewing chat on mobile */}
            {(!isMobile || !showChatViewOnMobile) && (
                <Grid item size={{ md: 4, xs: 12 }}>
                    <Paper elevation={3} sx={{ width: "100%" }}>
                        <Typography variant="h5" sx={{ p: 2, background: "var(--main-color)", color: "white" }}>
                            Messages
                        </Typography>
                        <Divider />
                        <Box sx={{ height: "70vh", overflowY: "auto" }}>
                            <List>
                                {GetAllChatRoomsWithReceiverInfo?.data?.rooms?.length > 0 ? (
                                    <>
                                        {GetAllChatRoomsWithReceiverInfo?.data?.rooms?.map((chat) => (
                                            <ListItem
                                                key={chat?.room_id}
                                                button
                                                selected={selectedChat?.chatRoom?.room_id === chat?.room_id}
                                                onClick={() => handleChatSelect(chat)}
                                                sx={{
                                                    backgroundColor: selectedChat?.chatRoom?.room_id === chat?.room_id ? "var(--main-contentbackgroundcolor)" : "white",
                                                    borderBottom: "1px solid gray",
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between', // Pushes content to left and right ends
                                                }}
                                            >
                                                {/* Left side: Avatar + Text */}
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Avatar src={chat?.receiver?.profileImage} sx={{ border: "1px solid gray", mr: 1 }} />
                                                    <ListItemText
                                                        primary={<Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '15px', color: 'black' }}>{`${capitalize(chat.receiver?.first_name)} ${capitalize(chat?.receiver?.last_name)}`}</Typography>}
                                                        secondary={<Typography variant="body1" sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', color: "gray" }}>{chat?.lastMessage?.content?.length > 10 ? (
                                                            <>
                                                                {chat.lastMessage.content.slice(0, 10)}...
                                                                <span style={{ color: 'var(--main-color)', cursor: 'pointer', fontSize: "12px" }}> more</span>
                                                            </>
                                                        ) : (
                                                            chat?.lastMessage?.content
                                                        )}</Typography>}
                                                    />
                                                </Box>
                                                {/* Right: Time + Badge */}
                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', minWidth: '50px', pr: 1 }}>
                                                    <Typography variant="caption" sx={{ color: 'gray', mb: 1, color: chat?.unreadMessageCount > 0 ? 'var(--main-color)' : 'black', fontSize: "9px" }}>
                                                        {formatTime(chat?.lastMessage?.createdAt)}
                                                    </Typography>
                                                    {chat?.unreadMessageCount > 0 && (
                                                        <Badge
                                                            color="error"
                                                            badgeContent={chat?.unreadMessageCount}
                                                            sx={{
                                                                mr: 2,
                                                                '& .MuiBadge-badge': {
                                                                    fontSize: '12px',
                                                                    height: '20px',
                                                                    minWidth: '20px',
                                                                    borderRadius: '50%',
                                                                    backgroundColor: 'var(--main-color)',

                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            </ListItem>
                                        ))}
                                    </>
                                ) : (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            minHeight: '40vh', // or adjust as needed
                                            width: '100%',
                                        }}
                                    >
                                        <Typography variant='subtitle1'>
                                            Please make connection to chat!
                                        </Typography>
                                    </Box>
                                )}
                            </List>
                        </Box>
                    </Paper>
                </Grid>
            )
            }

            {/* Chat View - show only on desktop or when selected on mobile */}
            {
                (!isMobile || showChatViewOnMobile) && selectedChat ? (
                    <Grid item size={{ md: 8, xs: 12 }}>

                        <Box sx={{ display: "flex", flexDirection: "column", height: "79vh", border: "1px solid gray", background: "var(--main-contentbackgroundcolor)" }}>
                            <Box sx={{ p: 1, background: "var(--main-color)", display: "flex", alignItems: "center" }}>
                                {isMobile && (
                                    <IconButton onClick={handleBackToChatList}>
                                        <ArrowBackIcon sx={{ color: "#fff" }} />
                                    </IconButton>
                                )}
                                <Avatar src={selectedChat?.chatRoom?.receiver?.profileImage} sx={{ border: "1px solid gray", mr: 1 }} />
                                <Typography variant="h6" sx={{ color: 'white' }}>{`${selectedChat?.chatRoom?.receiver?.first_name} ${selectedChat?.chatRoom?.receiver?.last_name}`}</Typography>
                            </Box>

                            <Box sx={{ flex: 1, overflowY: "auto", mb: 2, p: 2 }}>
                                {messages?.messages?.length > 0 ? (
                                    messages?.messages?.map((msg, index) => {

                                        return (
                                            <React.Fragment key={msg.message_id}>
                                                {getMessageDate(msg, index, selectedChat.messages)}

                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: msg?.you ? "flex-end" : "flex-start",
                                                        mb: 1,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            maxWidth: "70%",
                                                            p: 1,
                                                            borderRadius: 2,
                                                            backgroundColor: msg?.you ? "var(--main-color)" : "#e0e0e0",
                                                            color: msg?.you ? "#fff" : "#000",
                                                        }}
                                                    >

                                                        <Box
                                                            sx={{
                                                                maxWidth: "100%",
                                                                p: 0.5,
                                                                borderRadius: 2,
                                                                backgroundColor: msg?.you ? "var(--main-color)" : "#e0e0e0",
                                                                color: msg?.you ? "white" : "#000",
                                                            }}
                                                        >
                                                            {msg?.content}
                                                            {/* nfkfmkmfksak */}

                                                            <Typography variant="caption" sx={{ fontSize: "9px", color: msg?.you ? "white" : "var(--main-color)", paddingLeft: "8px", marginBottom: "-10px", position: "relative", bottom: "-10px", right: "0px" }}>
                                                                {/* {messageTime} */}
                                                                {formatTimeOnly(msg?.createdAt)}
                                                            </Typography>
                                                        </Box>




                                                    </Box>
                                                </Box>


                                            </React.Fragment>
                                        );
                                    })
                                ) : (
                                    <Typography>No messages yet...</Typography>
                                )}

                                <div ref={messagesEndRef} />
                            </Box>


                            <Box sx={{
                                mt: "auto",
                                // display: "flex",
                                // alignItems: "center",
                                p: 1,
                                borderTop: "1px solid #ddd",
                                backgroundColor: "#fff"
                            }}>

                                {/* <Formik
                                    initialValues={{ postText: '' }}
                                    onSubmit={(values, { resetForm }) => {
                                        handlePost(values);
                                        resetForm()
                                    }}
                                >
                                    {({ values, handleChange, handleSubmit, resetForm }) => (
                                        <Form onSubmit={handleSubmit}>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                placeholder="Message..."
                                                value={messageInput}
                                                onChange={(e) => setMessageInput(e.target.value)}
                                                sx={{ mr: 1 }}
                                            />

                                            <CustomInputWithEmoji
                                                name="message"
                                            />
                                            <IconButton color="primary" type="submit" onClick={() => {
                                                scrollToBottom();
                                                handleSend(messages)
                                            }}>
                                                <SendIcon />
                                            </IconButton>
                                        </Form>
                                    )}
                                </Formik> */}
                                <Formik
                                    initialValues={{ postText: '' }}
                                    onSubmit={(values, { resetForm }) => {
                                        // setMessageInput(values.postText);

                                        handleSend(messages, values?.postText);

                                        resetForm();
                                        scrollToBottom();

                                    }}
                                >
                                    {({ values, handleChange, handleSubmit }) => (
                                        <Form onSubmit={handleSubmit} style={{ display: 'flex', alignItems: 'center' }}>
                                            <CustomInputWithMessageEmoji
                                                name="postText"
                                                value={values.postText}
                                                onChange={handleChange}
                                                placeholder="Message..."
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' && !e.shiftKey) {
                                                        // setMessageInput(values.postText);

                                                        e.preventDefault(); // Prevent new line
                                                        handleSubmit();     // Submit on Enter
                                                    }
                                                    // Else allow Shift+Enter to go to next line (default behavior)
                                                }}
                                                fullWidth
                                            />
                                            <IconButton type="submit">
                                                <SendIcon style={{ color: "var(--main-color" }} />
                                            </IconButton>
                                        </Form>
                                    )}
                                </Formik>

                            </Box>

                        </Box>



                    </Grid>
                ) : (
                    <Grid item size={{ md: 8, xs: 12 }} sx={{ border: "1px solid lightgray" }}>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%"

                        }}>

                            <Typography variant="h6" sx={{ color: 'black' }}>Please select the chat to start the conversation</Typography>
                        </Box>
                    </Grid>
                )

            }
        </Grid >


    );
}

export default MessageChat;
